export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL
export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN
export const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY
